var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "div",
        { staticClass: "tip" },
        [
          _c("i", {
            staticClass: "el-icon-warning-outline",
            staticStyle: { color: "red", "font-weight": "bold" }
          }),
          _c("div", { staticClass: "content" }, [
            _vm._v(_vm._s(_vm.$t("Message.AfterTheCorrespondingCacheData")))
          ]),
          _c(
            "el-link",
            {
              staticClass: "link",
              attrs: { type: "primary" },
              on: { click: _vm.showSteps }
            },
            [_vm._v(_vm._s(_vm.$t("Message.ViewCacheRefreshMethod")))]
          ),
          _c(
            "el-dialog",
            {
              attrs: {
                visible: _vm.stepsDialog.show,
                title: _vm.$t("Message.RefreshCacheMethod")
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.stepsDialog, "show", $event)
                }
              }
            },
            [
              _c(
                "el-carousel",
                { attrs: { interval: 4000, height: "450px", weight: "" } },
                _vm._l(_vm.stepsDialog.stepsImgUrl, function(item) {
                  return _c("el-carousel-item", { key: item }, [
                    _c("img", {
                      attrs: { src: item, height: "100%", width: "100%" }
                    })
                  ])
                }),
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }